<template>
	<!-- div class="control buttons has-addons">
		<button type="button" class="button"><span class="icon"><i class="fal fa-step-backward"></i></span></button>
		<button type="button" class="button" v-on:click="toggleState">
			<span class="icon">
				<i v-if="playerState.isPlaying === false" class="fal fa-play"></i>
				<i v-if="playerState.isPlaying === true" class="fal fa-pause"></i>
			</span>
		</button>
		<button type="button" class="button"><span class="icon"><i class="fal fa-step-forward"></i></span></button>
	</div -->
</template>

<script>
  import { toHumanTime } from '../../Helpers';
  import findIndex from 'lodash/findIndex';

  const LOGGER_NAME = 'App.Tour.Route.RoutePlayer';

  export default {
    props: {
      app: Object,
      objects: Array,
      routeObjects: Array,
	  playerState: Object,
      updatePlayerState: Function
    },
    watch: {
      objects: {
        handler: function () {

        },
        immediate: true,
      },
	  playerState: {
        handler: function () {

        },
        immediate: true,
      },
    },
    data() {
      return {

	  }
	},
    computed: {
	},
    created: function() {
      this.log = debug(LOGGER_NAME);
      this.subscribeToPlayerEvents();
    },
    methods: {
      toHumanTime(value) {
        return toHumanTime(value);
      },
      subscribeToPlayerEvents() {

        this.log('Subscribing to player events..');

        ['play', 'playing', 'stop', 'pause', 'ended', 'timeupdate'].forEach((event) => {
          this.app.Events.subscribe('player.audio.' + event, (data) => {
            this.onPlayerEvent(event, data);
          });
        });

        ['next', 'prev'].forEach((event) => {
          this.app.Events.subscribe('player.audio.' + event, (data) => {
            this.onPlayerNavigateEvent(event, data);
          });
        });

	  },
      onPlayerEvent(event, data) {

        // Determine state
        let state = 'paused';

        if (['play', 'playing', 'timeupdate'].indexOf(event) >= 0) {
          state = 'playing';
		}

        // Calculate progress
		let progress = 0;
        if (data.media.currentTime > 0) {
        	progress = data.media.currentTime / data.media.duration * 100;
        }

        // Finalize player state
		let currentObject = this.getObjectIdByAudioPreviewUrl(data.media.currentSrc);
        let playerState = {
          currentObjectId:    (currentObject !== null ? currentObject.id : null),
		  currentObjectIndex: (currentObject !== null ? this.getPlayingObjectIndex(currentObject) : null),
          currentProgress:    progress, // 0 - 100%
          state:              state
        };

        // this.log('onPlayerEvent:', playerState);
		let isWithPlaylist = (currentObject !== null && this.isInRoute(currentObject));
        this.app.Events.publish('player.audio.playlistStatus', isWithPlaylist);

        this.updatePlayerState(playerState);

        if (event === 'ended') {
          this.onPlayerNavigateEvent('next', true);
		}

	  },
      onPlayerNavigateEvent(event, data) {

        let newPlayingObjectIndex = null,
		  	currentPlayingObjectIndex = this.playerState.currentObjectIndex;

        // this.log('Current playing object index:', currentPlayingObjectIndex);

        // If no current playing route object
		// choose first
        if (currentPlayingObjectIndex == null) {
          newPlayingObjectIndex = 0;
		}

        // If have not new playing object index, determine it by next/prev event
        if (newPlayingObjectIndex === null) {
          if (event === 'next') {

            // If next object exists choose it, otherwise choose the first
			if (typeof this.routeObjects[currentPlayingObjectIndex + 1] !== 'undefined') {
              newPlayingObjectIndex = ++currentPlayingObjectIndex;
			} else {
              newPlayingObjectIndex = 0;
			}

          } else if (event === 'prev') {

            // If prev object exists choose it, otherwise choose the last
            if (typeof this.routeObjects[currentPlayingObjectIndex - 1] !== 'undefined') {
              newPlayingObjectIndex = --currentPlayingObjectIndex;
            } else {
              newPlayingObjectIndex = this.routeObjects.length - 1;
            }
          }
        }

        // this.log('next Playing object will be with index:', newPlayingObjectIndex);

		// Play object
		let nextObject = this.routeObjects[newPlayingObjectIndex];
        if (typeof nextObject !== 'undefined') {
          // play by src nextObject.audio_preview;
		  this.app.Events.publish('player.audio.play-next', {
		    src:   nextObject.audio_preview,
			title: (this.getPlayingObjectIndex(nextObject) + 1) +'. '+ nextObject.title
		  });
		}

      },
	  getObjectIdByAudioPreviewUrl(url) {

		let object = this
			.objects
			.filter(object => {
			return object.audio_preview === url
			})[0];

		return typeof object !== 'undefined' ? object : null;

	  },
      isInRoute(object) {
        return this
          .routeObjects
          .filter(routeObject => {
            return routeObject.id === object.id
          })
          .length === 1;
      },

      getPlayingObjectIndex(object) {
        if (this.isInRoute(object)) {
          return findIndex(this.routeObjects, {id: object.id})
        }
        return null;
      },
    }
  }
</script>